import React from 'react';

export default function OcrIcon({className = "size-6"}) {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
                fill="none" className={className}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 8V6a2 2 0 0 1 2-2h2"></path>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 4h2a2 2 0 0 1 2 2v2"></path>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16v2a2 2 0 0 0 2 2h2"></path>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h2a2 2 0 0 0 2-2v-2"></path>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 11a1.5 1.5 0 0 1 3 0v2a1.5 1.5 0 0 1-3 0v-2Z"></path>
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M13.5 9.5h-1a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5h1"></path>
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M15.5 9.5v5m0-5h1.5a1.25 1.25 0 0 1 0 2.5H15.5m1.5 0 1.5 2.5"></path>
    </svg>
}
